"use strict";

exports.__esModule = true;
exports.applyElementPropConstraints = applyElementPropConstraints;
var _getWidget = require("./getWidget");
var _alignTo = require("./alignTo");
/**
 * Apply constraints to the properties of an element,
 * returning a new element with the constraints applied..
 */
function applyElementPropConstraints(widgets, parent, element, newProps) {
  var type = element.type,
    children = element.children;
  var widget = (0, _getWidget.getWidgetOrThrow)(widgets, type);
  var props = mergeProperties(widgets, parent, element, newProps);
  var defaultWidth = widget.propConstraints.width["default"];
  var defaultHeight = widget.propConstraints.height["default"];
  var minWidth = widget.propConstraints.width.min;
  var minHeight = widget.propConstraints.height.min;
  var maxWidth = widget.propConstraints.width.max;
  var maxHeight = widget.propConstraints.height.max;
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    width = props.width,
    height = props.height;
  if (typeof x !== "number" || !Number.isFinite(x) || x < 1) {
    x = 0;
  }
  if (typeof y !== "number" || !Number.isFinite(y) || y < 1) {
    y = 0;
  }
  if (typeof width !== "number" || !Number.isFinite(width)) {
    width = defaultWidth;
  }
  if (typeof height !== "number" || !Number.isFinite(height)) {
    height = defaultHeight;
  }
  if (parent !== undefined) {
    maxWidth = Math.min(maxWidth, getContainerWidth(parent));
    maxHeight = Math.min(maxHeight, getContainerHeight(parent));
  }
  var availableWidth = maxWidth - x;
  var availableHeight = maxHeight - y;
  if (width > availableWidth) {
    width = availableWidth;
  }
  if (height > availableHeight) {
    height = availableHeight;
  }
  props.x = Math.max(0, (0, _alignTo.alignTo)(x, 16));
  props.y = Math.max(0, (0, _alignTo.alignTo)(y, 16));
  props.height = (0, _alignTo.alignTo)(Math.max(minHeight, height), 16);
  props.width = (0, _alignTo.alignTo)(Math.max(minWidth, width), 16);
  return {
    type: type,
    props: props,
    children: children
  };
}
function mergeProperties(widgets, parent, element, newProps) {
  var oldProps = element.props;
  if (parent !== undefined) {
    var parentWidget = (0, _getWidget.getWidgetOrThrow)(widgets, parent.type);
    var props = {};
    for (var _i = 0, _Object$keys = Object.keys(oldProps); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (!(key in newProps) && !parentWidget.suppliesProps.includes(key)) {
        props[key] = oldProps[key];
      }
    }
    for (var _i2 = 0, _Object$keys2 = Object.keys(newProps); _i2 < _Object$keys2.length; _i2++) {
      var _key = _Object$keys2[_i2];
      if (!parentWidget.suppliesProps.includes(_key)) {
        props[_key] = newProps[_key];
      }
    }
    return props;
  }
  return Object.assign({}, oldProps, newProps);
}
function getContainerWidth(parent) {
  if (typeof parent.props.itemWidth === "number") {
    return parent.props.itemWidth;
  }
  if (typeof parent.props.width === "number") {
    return parent.props.width;
  }
  return 3840;
}
function getContainerHeight(parent) {
  if (typeof parent.props.itemHeight === "number") {
    return parent.props.itemHeight;
  }
  if (typeof parent.props.height === "number") {
    return parent.props.height;
  }
  return 2160;
}